import {StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load. Style-as-function entries are
// preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      ...CommonStyles.full_height,
      ...CommonStyles.p_32,
    },
    emptyListContainer: isFromCheckout => ({
      ...CommonStyles.flex_center,
      minHeight: isFromCheckout ? '0' : '100vh',
    }),
    addNewAddressButton: {
      ...CommonStyles.ph_16,
      ...CommonStyles.br_16,
    },
    addNewAddressText: {
      ...CommonStyles.flex_row,
      ...CommonStyles.items_center,
      ...CommonStyles.mt_16,
    },
    contentContainer: {
      width: '66%',
      backgroundColor: colors.surface,
      ...CommonStyles.p_24,
      ...CommonStyles.br_16,
    },
    deleteButton: {
      flex: 1,
      marginLeft: 16,
      backgroundColor: colors.danger,
    },
    list: {
      flex: 1,
      marginTop: 8,
    },
    listItemContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingVertical: 24,
    },
    nameContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    userIcon: {
      tintColor: colors.link,
      marginRight: 20,
      width: 17,
      height: 21,
    },
    optionIcon: {
      height: 15,
      width: 15,
      tintColor: colors.textPrimary,
      resizeMode: 'contain',
      paddingVertical: 10,
    },
    optionContainer: {
      borderRadius: 16,
      paddingHorizontal: 16,
    },
    optionWrapper: {
      paddingVertical: 16,
      borderBottomColor: colors.border,
      borderBottomWidth: 1,
    },
    paddingVertical16: {
      paddingVertical: 16,
    },
    paddingHorizontal24: {
      paddingHorizontal: 24,
    },
    buttonContainer: {
      paddingHorizontal: 24,
      marginBottom: 24,
    },
    itemContainer: isDefault => ({
      paddingHorizontal: 24,
      backgroundColor: isDefault ? colors.accentSubtle : colors.transparent,
    }),
    p10: {
      padding: 10,
    },
    checkoutContainer: {
      marginHorizontal: 24,
      marginVertical: 16,
    },
  });

export default makeStyles;
